import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Loader from '../components/common/Loader';

const StaffRoute = ({ children }) => {
  const { isAuthenticated, canManageOrders, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!canManageOrders) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default StaffRoute;
